import { useEffect, useState } from "react";
import NavBar from "../../../components/organisms/navbar";
import {
  Container,
  Content,
  InfoContainerStatus,
  InfoContainerText,
  PageTitle,
  PageTitleContainer,
  StatusButton,
  SubscriptionContainer,
  SubscriptionContent,
  SubscriptionDescription,
  SubscriptionItem,
  SubscriptionList,
  SubscriptionTitle,
} from "../../profile/subscriptions/styles";
import api from "../../../services/api";
import { toast } from "react-toastify";
import useAuthenticate from "../../../hooks/useAuthenticate";
import Loading from "../../../components/atoms/loading";
import React from "react";
import EditIcon from "@mui/icons-material/Edit";
import { useNavigate, useParams } from "react-router-dom";
import { StringToSlug, StringToSlugPraia } from "../../../utils/SlugConverter";
import { TournamentLink } from "src/pages/tournament/styles";
import { FormContent } from "src/pages/auth/change-password/styles";
import { useForm } from "react-hook-form";
import { FormGroup } from "../../../pages/auth/login/styles";
import Input from "../../../components/atoms/input";
import BasicModal from "src/components/organisms/tournamentBracket/modal";
import {
  Box,
  Button,
  Fab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Zoom,
} from "@mui/material";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Swal from "sweetalert2";
import { HistoryModal } from "src/components/atoms/historyModal";
import HistoryIcon from "@mui/icons-material/History";
import { ScrollableTable } from "src/components/atoms/reportTable";

import rulesGi from "../../../data/rules-sti-open-kids-de-jiu-jitsu-2026-gi.json";
import rulesNoGi from "../../../data/rules-sti-open-kids-de-jiu-jitsu-2026-nogi.json";

const slugGi = "sti-open-kids-de-jiu-jitsu-santa-terezinha-de-itaipu-pr-gi";
const slugNoGi = "sti-open-kids-de-jiu-jitsu-santa-terezinha-de-itaipu-pr-nogi";

//let REGRA_CHAVE_3 = "chaveDe3Simples";
// ou:
let REGRA_CHAVE_3 = "chaveDe3MelhorDe3";

const AllCheckCategoriesStiOpenKidsDeJiuJitsu2026 = () => {
  //let senha = "teste"
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  let password = {
    torneio: "stiopenkids@2026",
    credenciais: {
      usuario: "stiopenkids",
      senha: "stiopenkids@2026",
    },
  };

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const { getToken, account } = useAuthenticate();
  const [dataTratada, setDataTratada] = useState<
    { category: string; figthers: any }[]
  >([]);
  const [showData, setShowData] = useState(false);
  const url = window.location.pathname;
  const { slug } = useParams();
  const [tournament, setTournament] = useState<any>({});
  const [subscription, setSubscription] = useState<any>([]);
  const [senha, setSenha] = useState(""); // Estado para armazenar o valor da senha digitada
  const [isAuthorized, setIsAuthorized] = useState(false); // Estado para controlar a exibição do relatório
  const navigate = useNavigate();
  const [manager, setManager] = useState<boolean>(false);
  const [visible, setVisible] = useState(false);
  const [historyData, setHistoryData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [countCategories, setCountCategories] = useState<any>([]);
  const [ignore, setIgnore] = useState({
    category: false,
    gender: false,
    belt: false,
    weight: false,
  });
  const [filterShirt, setFilterShirt] = useState<"all" | "with" | "without">(
    "all"
  );

  const toggleIgnore = (key: keyof typeof ignore) => {
    setIgnore((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const [genderFilter, setGenderFilter] = useState<
    "all" | "masculino" | "feminino"
  >("all");

  const filterByGender = (data: any[]) => {
    if (genderFilter === "all") return data;
    return data.filter((value) => value.genre?.toLowerCase() === genderFilter);
  };

  const handleCheckPassword = (data: any) => {
    if (data.password === password.credenciais.senha) {
      setIsAuthorized(true); // Exibe o relatório se a senha estiver correta
    } else {
      alert("Senha incorreta"); // Exibe um alerta se a senha estiver errada
    }
  };

  const handleEditFighter = (fighterId: number) => {
    if (manager) {
      Swal.fire({
        title: "Como deseja editar sua inscrição?",
        text: "Você pode editar seguindo as regras do evento ou livremente.",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonColor: "#373737",
        confirmButtonText: "Editar com regras",
        denyButtonText: "Editar sem regras",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed)
          navigate(`/enrollment-update/${fighterId}/${slug}`, {
            state: { from: url, mode: "regras" },
          });
        else if (result.isDenied)
          navigate(`/enrollment-update/${fighterId}/${slug}`, {
            state: { from: url, mode: "livre" },
          });
      });
    } else {
      navigate(`/enrollment-update/${fighterId}/${slug}`, {
        state: { from: url },
      });
    }
  };

  const showHistorySubsModal = async (subscriptionId: number) => {
    await api
      .get(`/history/Subscription/${subscriptionId}`, {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      })
      .then((res) => {
        setHistoryData(res.data);
        setIsModalOpen(true);
      });
  };

  const parseWeightOrder = (peso: string): number => {
    const lower = peso.toLowerCase().trim();

    // separa parte textual + número
    const match = lower.match(/^([a-z\sç]+?)(\d+)?$/i);

    if (match) {
      const base = match[1].trim(); // "galo", "pluma", "medio"...
      const num = match[2] ? Number(match[2]) : 0; // se não tiver número, fica 0

      const baseOrder = weightOrder[base] ?? 999; // se não existir no mapper, vai pro fim

      // ex: galo (2) -> 2.00 ; galo1 -> 2.01 ; galo2 -> 2.02
      return baseOrder + num * 0.01;
    }

    return 999; // fallback
  };

  const normalize = (v: unknown) =>
    (v ?? "")
      .toString()
      .trim()
      .toLowerCase()
      .normalize("NFD") // separa acentos
      .replace(/[\u0300-\u036f]/g, "") // remove acentos
      .replace(/\s*-\s*/g, "-") // normaliza hífens com espaços
      .replace(/\s+/g, " "); // colapsa espaços

  console.log(normalize("MÉDIO1"));

  // "parajiu jitusu - adulto" -> "adulto"
  const normalizeCategory = (cat: unknown) => {
    const n = normalize(cat);
    if (!n) return n;
    const parts = n.split("-").map((p) => p.trim());
    return parts[parts.length - 1] || n;
  };

  const getOrder = <T extends string>(
    map: Record<string, number>,
    key: unknown,
    fallback = 999
  ) => map[normalize(key as string)] ?? fallback;

  const baseCategory = (raw: unknown) => {
    const n = normalize(raw); // sua função "forte" sem acento, espaços normalizados
    if (!n) return n;

    // Só separa quando há traço COM espaços ao redor (prefixos do tipo "xxx - yyy")
    if (/\s[-–—]\s/.test(n)) {
      const parts = n.split(/\s[-–—]\s/);
      return parts[parts.length - 1] || n;
    }

    // Sem " - " com espaços? então é nome composto (ex.: "pre-mirim") → mantém inteiro
    return n;
  };

  const beltOrderSafe = (beltRaw: unknown, beltMap: Record<string, number>) => {
    const b = normalize(beltRaw);
    if (!b) return 999;

    // 1) Se existir "cinza e amarela" no mapa, usa direto (RESOLVE seu caso)
    if (b in beltMap) return beltMap[b];

    // 2) Senão, se for combinado, deriva a ordem pelas partes
    if (b.includes(" e ")) {
      const parts = b.split(" e ").map((x) => x.trim());
      const nums = parts.map((p) => beltMap[p] ?? 999);
      // pode usar Math.min (mais "leve") ou Math.max (mais "alta")
      return Math.min(...nums);
    }

    // 3) Faixa simples
    return beltMap[b] ?? 999;
  };

  const weightOrderSafe = (wRaw: unknown, wMap: Record<string, number>) =>
    wMap[normalize(wRaw)] ?? 999;

  // força feminino antes de masculino
  const genderOrderMap: Record<string, number> = {
    feminino: 1,
    masculino: 2,
  };

  const genderOrderSafe = (gRaw: unknown) =>
    genderOrderMap[normalize(gRaw)] ?? 99;

  // extrai campos do seu `title` "categoria/gênero/faixa/peso"
  const parseTitle = (title: string) => {
    const [cat, gen, belt, weight] = title.split("/");
    return {
      catRaw: cat ?? "",
      genRaw: gen ?? "",
      beltRaw: belt ?? "",
      weightRaw: weight ?? "",
      catBase: baseCategory(cat),
    };
  };

  const isParaOrPCD = (catRaw: unknown) => {
    const c = normalize(catRaw);
    // considera "pcd ..." ou "parajiu ..." (qualquer variação de espaços/letras)
    return c.startsWith("pcd") || c.startsWith("parajiu");
  };

  // PRIMEIRO FEMININO DEPOIS MASCULINO

  const categoryOrder: { [key: string]: number } = {
    "pre-mirim": 1,
    "mirim a": 2,
    "mirim b": 3,
    "infantil a": 4,
    "infantil b": 5,
    "infanto juvenil": 6,
    juvenil: 7,
    adulto: 8,
    "master 1 e 2": 9,
    "master 3, 4 e 5": 10,
  };

  const beltOrder: { [key: string]: number } = {
    branca: 1,
    graduado: 2,
    cinza: 3,
    amarela: 4,
    laranja: 5,
    verde: 6,
    "laranja e verde": 7,
    azul: 8,
    roxa: 9,
    marrom: 10,
    preta: 11,
  };

  const weightOrder: { [key: string]: number } = {
    galo: 1,
    pluma: 2,
    pena: 3,
    leve: 4,
    medio: 5,
    "meio pesado": 6,
    pesado: 7,
    "super pesado": 8,
    pesadissimo: 9,
    "absoluto (galo a leve)": 10,
    "absoluto (medio a pesadissimo)": 11,
    absoluto: 12,
  };

  interface User {
    id: number;
    name: string;
    phone: string;
    email: string;
    gym: string;
    genre: string;
  }

  interface Fighter {
    id: number;
    weight: string;
    genre: string;
    age: string;
    belt: string;
    category: string;
    valueSubscription: string;
    status: boolean;
    created_at: string;
    updated_at: string;
    userId: number;
    fightersId: number | null;
    tournamentId: number;
    fighters: any;
    user: User;
  }

  function converterSubscriptions(array: any) {
    const subscriptions: {
      id: any;
      weight: any;
      age: any;
      gender: any;
      genderBool: string;
      belt: any;
      category: any;
      name: any;
      gymAbre: any;
      gym: any;
      status: any;
      value: any;
      categoryw: any;
    }[] = [];
    array.forEach((item: any) => {
      let fighterBelt = item.belt;
      if (item.belt === "laranja" || item.belt === "verde") {
        fighterBelt = "laranja e verde";
      }
      if (item.belt === "cinza" || item.belt === "amarela") {
        fighterBelt = "cinza e amarela";
      }

      let category;

      category = StringToSlug(
        `${fighterBelt}/${item.genre}/${item.weight}/${item.category}`
      );

      if (item.fighters && item.status) {
        subscriptions.push({
          id: item.id,
          weight: item.weight,
          age: item.age,
          gender: item.fighters.genre,
          genderBool:
            item.fighters.genre === "Masculino" ? "Falso" : "Verdadeiro",
          belt: item.belt,
          category: item.category,
          name: item.fighters.name,
          gymAbre: item.fighters.gym.substring(0, 12),
          gym: item.fighters.gym,
          status: item.status,
          categoryw: category, // This `categoryw` is the slug, not used for sorting here
          value: item.valueSubscription,
        });
      }

      if (!item.fighters && item.status) {
        subscriptions.push({
          id: item.id,
          weight: item.weight,
          age: item.age,
          gender: item.user.genre,
          genderBool: item.user.genre === "masculino" ? "Falso" : "Verdadeiro",
          belt: item.belt,
          category: item.category,
          name: item.user.name,
          gymAbre: item.user.gym.substring(0, 12),
          gym: item.user.gym,
          status: item.status,
          categoryw: category, // This `categoryw` is the slug, not used for sorting here
          value: item.valueSubscription,
        });
      }
    });

    function categorizeParticipants(participants: any) {
      let categories: any = {};

      participants.forEach((participant: any) => {
        let fighterBelt = participant.belt;
        if (participant.belt === "laranja" || participant.belt === "verde") {
          fighterBelt = "laranja e verde";
        }
        if (participant.belt === "cinza" || participant.belt === "amarela") {
          fighterBelt = "cinza e amarela";
        }

        const categoryIdentifier = `${participant.category.toLowerCase()}/${participant.genre.toLowerCase()}/${fighterBelt.toLowerCase()}/${
          participant.weight
        }`;

        if (!categories[categoryIdentifier]) {
          categories[categoryIdentifier] = [];
        }

        categories[categoryIdentifier].push(participant);
      });

      let categoriesArray = Object.keys(categories).map((title) => {
        const { catRaw, genRaw, beltRaw, weightRaw, catBase } =
          parseTitle(title);

        return {
          title,
          data: categories[title],
          // 0 = normal; 1 = PCD/Parajiu  → empurramos pro final
          prefixOrderVal: isParaOrPCD(catRaw) ? 1 : 0,

          // ordem já corrigida anteriormente
          categoryOrderVal: categoryOrder[catBase] ?? 999,
          genderOrderVal: genderOrderSafe(genRaw),
          beltOrderVal: beltOrderSafe(beltRaw, beltOrder),
          weightOrderVal: parseWeightOrder(normalize(weightRaw)),
        };
      });

      console.log("ARRRRARARA", categoriesArray);

      categoriesArray.sort((a, b) => {
        // 1) Normal antes; PCD/Parajiu no fim
        if (a.prefixOrderVal !== b.prefixOrderVal) {
          return a.prefixOrderVal - b.prefixOrderVal;
        }
        // 2) Categoria (sufixo após "-")
        if (a.categoryOrderVal !== b.categoryOrderVal) {
          return a.categoryOrderVal - b.categoryOrderVal;
        }
        // 3) Gênero (feminino antes de masculino)
        if (a.genderOrderVal !== b.genderOrderVal) {
          return a.genderOrderVal - b.genderOrderVal;
        }
        // 4) Faixa
        if (a.beltOrderVal !== b.beltOrderVal) {
          return a.beltOrderVal - b.beltOrderVal;
        }
        // 5) Peso
        return a.weightOrderVal - b.weightOrderVal;
      });

      console.log(categoriesArray);

      setSubscription(categoriesArray);

      const teste = categoriesArray.map((item: any) => ({
        title: item.title,
        total: item.data.length,
      }));

      setCountCategories(teste);

      const dataTratadaArr: {
        category: string;
        figthers: any;
        order: number;
      }[] = [];

      categoriesArray.forEach((category, index: number) => {
        dataTratadaArr.push({
          category: category.title,
          order: index + 1,
          figthers: category.data.map((item: any) => {
            if (item.fighters == null) {
              return {
                name: item.user.name,
                gym: item.user.gym,
                belt: item.belt,
                weight: item.weight,
              };
            } else {
              return {
                name: item.fighters.name,
                gym: item.fighters.gym,
                belt: item.belt,
                weight: item.weight,
              };
            }
          }),
        });
      });

      setDataTratada(dataTratadaArr);
    }

    categorizeParticipants(array);
  }

  useEffect(() => {
    if (
      account?.roles?.includes("manager") ||
      tournament.authorId === account.id
    ) {
      setManager(true);
    } else {
      setManager(false);
    }
  }, [account]);

  useEffect(() => {
    setLoading(true);

    api
      .get("/tournaments/" + slug)
      .then(({ data }) => {
        setTournament(data);
      })
      .catch(() => {
        toast.error("Não foi carregar os dados do torneio.");
      });

    api
      .get("/tournaments/enrollments/list-all/public/" + slug, {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      })
      .then(({ data }) => {
        setLoading(false);

        const sortedArray = data
          .filter((item: Fighter) => item.status === true)
          .slice()
          .sort((a: Fighter, b: Fighter) => {
            const aGenre = normalize(a.genre);
            const bGenre = normalize(b.genre);

            // 1) Feminino antes de Masculino
            if (aGenre !== bGenre) {
              if (aGenre === "feminino") return -1;
              if (bGenre === "feminino") return 1;
            }

            // 2) Categoria (usando sufixo após "-")
            const aCat = normalizeCategory(a.category);
            const bCat = normalizeCategory(b.category);
            const catDiff =
              getOrder(categoryOrder, aCat) - getOrder(categoryOrder, bCat);
            if (catDiff !== 0) return catDiff;

            // 3) Faixa (belt)
            const beltDiff =
              beltOrderSafe(a.belt, beltOrder) -
              beltOrderSafe(b.belt, beltOrder);
            if (beltDiff !== 0) return beltDiff;

            // 4) Peso
            const weightDiff =
              getOrder(weightOrder, a.weight) - getOrder(weightOrder, b.weight);
            if (weightDiff !== 0) return weightDiff;

            // (opcional) 5) Desempate por nome para estabilidade
            const aName = normalize(a.user?.name);
            const bName = normalize(b.user?.name);
            return aName.localeCompare(bName);
          });

        setData(sortedArray);

        if (data && subscription.length === 0)
          converterSubscriptions(sortedArray);

        setShowData(true);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
        toast.error("Não foi carregar os dados das inscrições.");
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 300); // mostra só depois de rolar 300px
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (loading) return <Loading text="Aguarde, estamos processando os dados." />;

  let quantidadeInscrcaoPagas = data.length;
  let quatidadeDeChaves = subscription.filter(
    (item: any) => item.data.length > 0
  ).length;
  let quatidadeDeChavesSemLuta = subscription.filter(
    (item: any) => item.data.length === 1
  ).length;

  let medalhasBronze = subscription.filter(
    (item: any) => item.data.length > 2
  ).length;
  let medalhasPrata =
    medalhasBronze +
    subscription.filter((item: any) => item.data.length === 2).length;
  let medalhasOuro =
    medalhasPrata +
    subscription.filter((item: any) => item.data.length === 1).length;

  const columns = [
    { label: "Categoria", key: "title" },
    { label: "Atletas", key: "total" },
  ];

  const getPesoMaximo = (subs: any) => {
    let rulesPesoMaximo;

    if (slug === slugGi) {
      rulesPesoMaximo = rulesGi;
    }

    if (slug === slugNoGi) {
      rulesPesoMaximo = rulesNoGi;
    }

    if (!rulesPesoMaximo) return null;

    return (
      rulesPesoMaximo.find(
        (item: any) =>
          item.genero?.toLowerCase() === subs.genre?.toLowerCase() &&
          item.categoria?.toLowerCase() === subs.category?.toLowerCase() &&
          item.peso?.descricao?.toLowerCase() === subs.weight?.toLowerCase() &&
          item.faixa?.some(
            (f: any) => f.nome?.toLowerCase() === subs.belt?.toLowerCase()
          )
      )?.peso?.max || null
    );
  };

  const getTempoDeLuta = (subs: any) => {
    const regras = slug === slugGi ? rulesGi : rulesNoGi;
    if (!regras) return null;

    const regraCategoria = regras.find(
      (item: any) =>
        item.genero?.toLowerCase() === subs.genre?.toLowerCase() &&
        item.categoria?.toLowerCase() === subs.category?.toLowerCase() &&
        //item.peso?.descricao?.toLowerCase() === subs.weight?.toLowerCase() &&
        item.faixa?.some(
          (f: any) => f.nome?.toLowerCase() === subs.belt?.toLowerCase()
        )
    );

    if (!regraCategoria) return null;

    const faixa = regraCategoria.faixa.find(
      (f: any) => f.nome?.toLowerCase() === subs.belt?.toLowerCase()
    );

    return faixa?.tempodeLuta || null;
  };

  return (
    <>
      <NavBar />
      <Container>
        <Content id="todaslutas">
          <PageTitleContainer>
            <Typography
              sx={{
                fontSize: "2.0rem",
                fontFamily: "inter, sans-serif",
                fontWeight: 400,
              }}
            >
              CHECAGEM {tournament.name}
            </Typography>

            <Typography
              sx={{
                color: "red",
                fontSize: "1.8rem",
                fontFamily: "inter, sans-serif",
              }}
            >
              Somente inscrições pagas aparecem na checagem
            </Typography>

            {/* Filtro de gênero */}
            <Box sx={{ display: "flex", gap: 1, mt: 2 }}>
              <Button
                variant={genderFilter === "all" ? "contained" : "outlined"}
                onClick={() => setGenderFilter("all")}
              >
                Todas
              </Button>
              <Button
                variant={
                  genderFilter === "masculino" ? "contained" : "outlined"
                }
                onClick={() => setGenderFilter("masculino")}
              >
                Masculino
              </Button>
              <Button
                variant={genderFilter === "feminino" ? "contained" : "outlined"}
                onClick={() => setGenderFilter("feminino")}
              >
                Feminino
              </Button>
            </Box>

            <Box sx={{ display: "flex", flexDirection: "row", gap: 1, mt: 2 }}>
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#373737",
                  fontFamily: "inter, sans serif",
                }}
                onClick={() => {
                  const section = document.getElementById("semlutas");
                  section?.scrollIntoView({ behavior: "smooth" });
                }}
              >
                Chaves sem lutas
              </Button>

              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#373737",
                  fontFamily: "inter, sans serif",
                }}
                onClick={() => {
                  const section = document.getElementById("relatorioTorneio");
                  section?.scrollIntoView({ behavior: "smooth" });
                }}
              >
                Relatório do Torneio
              </Button>

              {account.id == 34 && (
                <BasicModal
                  chaves={dataTratada}
                  tournamentId={tournament.id}
                  tournamentName={tournament.name}
                  tournamentDate={tournament.date}
                  tournamentLocation={tournament.location}
                  tournamentRules={tournament.rules}
                />
              )}
            </Box>

            <Typography
              sx={{
                fontSize: "1.8rem",
                fontFamily: "inter, sans-serif",
                fontWeight: "bold",
                mt: 3,
              }}
            >
              TODAS AS LUTAS
            </Typography>
          </PageTitleContainer>

          <SubscriptionContainer>
            {/* renderizar as inscrições para cada categoria */}
            {subscription.map((item: any, index: number) => {
              const filteredData = filterByGender(item.data); // << filtro aqui

              filteredData.sort((a: any, b: any) => {
                const nomeA = (
                  a.fighters ? a.fighters.name : a.user.name
                ).toLowerCase();
                const nomeB = (
                  b.fighters ? b.fighters.name : b.user.name
                ).toLowerCase();
                return nomeA.localeCompare(nomeB);
              });

              if (showData && filteredData.length > 0) {
                return (
                  <React.Fragment key={item.title}>
                    <br></br>
                    <PageTitle>
                      {index + 1} - {item.title}
                    </PageTitle>
                    {filteredData.map((value: any, index: number) => (
                      <SubscriptionList key={value.id}>
                        <SubscriptionItem
                          style={{
                            backgroundColor:
                              value.genre?.toLowerCase() === "feminino"
                                ? "#fee0f1"
                                : "#DBECF4", // rosa claro no feminino
                          }}
                        >
                          <SubscriptionContent>
                            {/* <SubscriptionTitle>
                              Inscrição Nº {value.id} -{tournament.name}
                            </SubscriptionTitle> */}
                            {/* <br /> */}
                            <SubscriptionDescription>
                              <InfoContainerText>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    width: "100%",
                                  }}
                                >
                                  <div style={{ flexGrow: 1 }}>
                                    <span>
                                      <b>{index + 1}. </b>
                                      {(value.fighters
                                        ? value.fighters.name
                                        : value.user.name
                                      ).toLocaleUpperCase()}
                                      {
                                        //value.weight?.toUpperCase() +
                                        manager ? ` - ${value.age} anos` : ""
                                      }
                                    </span>
                                  </div>
                                  <div
                                    style={{
                                      display: "flex",
                                      flexShrink: 0,
                                      textAlign: "right",
                                      alignContent: "center",
                                      gap: 5,
                                    }}
                                  >
                                    <span>
                                      {(value.fighters
                                        ? value.fighters.gym
                                        : value.user.gym
                                      ).toLocaleUpperCase()}{" "}
                                    </span>

                                    {(value.userId === account.id ||
                                      manager) && (
                                      <>
                                        <HistoryIcon
                                          color="action"
                                          sx={{ cursor: "pointer" }}
                                          onClick={() =>
                                            showHistorySubsModal(value.id)
                                          }
                                        />{" "}
                                        <EditIcon
                                          color="action"
                                          sx={{ cursor: "pointer" }}
                                          onClick={() =>
                                            handleEditFighter(value.id)
                                          }
                                        />
                                      </>
                                    )}
                                  </div>
                                </div>

                                {/* <span>Professor: ORLEY LOBATO</span><br/> */}
                              </InfoContainerText>
                            </SubscriptionDescription>
                          </SubscriptionContent>
                        </SubscriptionItem>
                      </SubscriptionList>
                    ))}
                    <br></br> <br></br>
                  </React.Fragment>
                );
              } else {
                // não há atletas nesta categoria, então não renderizar nada
                return null;
              }
            })}
          </SubscriptionContainer>
        </Content>

        <Content id="semlutas">
          <PageTitleContainer>
            <Typography
              sx={{
                fontSize: "1.8rem",
                fontFamily: "inter, sans-serif",
                fontWeight: "bold",
                mt: 2,
              }}
            >
              {
                subscription.filter((item: any) => item.data.length === 1)
                  .length
              }{" "}
              CHAVES SEM LUTAS (TOTAL)
            </Typography>

            <Typography
              sx={{
                fontSize: "1.8rem",
                fontFamily: "inter, sans-serif",
                fontWeight: "bold",
                mt: 2,
              }}
            >
              {
                subscription.filter(
                  (item: any) => filterByGender(item.data).length === 1
                ).length
              }{" "}
              CHAVES SEM LUTAS (FILTRADAS)
            </Typography>

            <Box sx={{ display: "flex", flexDirection: "row", gap: 1, mt: 2 }}>
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#373737",
                  fontFamily: "inter, sans serif",
                }}
                onClick={() => {
                  const section = document.getElementById("semlutas");
                  section?.scrollIntoView({ behavior: "smooth" });
                }}
              >
                Chaves sem lutas
              </Button>

              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#373737",
                  fontFamily: "inter, sans serif",
                }}
                onClick={() => {
                  const section = document.getElementById("relatorioTorneio");
                  section?.scrollIntoView({ behavior: "smooth" });
                }}
              >
                Relatório do Torneio
              </Button>
            </Box>
          </PageTitleContainer>

          <SubscriptionContainer>
            {/* renderizar as inscrições para cada categoria */}
            {subscription
              .filter((item: any) => filterByGender(item.data).length === 1)
              .map((item: any) => {
                const filteredData = filterByGender(item.data); // << filtro aqui também

                filteredData.sort(
                  (a: { age: number }, b: { age: number }) => a.age - b.age
                );

                if (showData && filteredData.length > 0) {
                  return (
                    <React.Fragment key={item.title}>
                      <PageTitle>{item.title}</PageTitle>
                      {filteredData.map((value: any, index: number) => (
                        <SubscriptionList key={value.id}>
                          <SubscriptionItem
                            style={{
                              backgroundColor:
                                value.genre?.toLowerCase() === "feminino"
                                  ? "#fee0f1"
                                  : "#DBECF4", // rosa claro no feminino
                            }}
                          >
                            {/* <SubscriptionItem> */}
                            <SubscriptionContent>
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <SubscriptionTitle>
                                  {/* Inscrição Nº {value.id} -{tournament.name} */}
                                  Inscrição Nº {value.id}{" "}
                                </SubscriptionTitle>

                                <Box>
                                  {(value.userId === account.id || manager) && (
                                    <>
                                      <HistoryIcon
                                        color="action"
                                        sx={{ cursor: "pointer" }}
                                        onClick={() =>
                                          showHistorySubsModal(value.id)
                                        }
                                      />{" "}
                                      <EditIcon
                                        color="action"
                                        sx={{ cursor: "pointer" }}
                                        onClick={() =>
                                          handleEditFighter(value.id)
                                        }
                                      />
                                    </>
                                  )}
                                </Box>
                              </Box>
                              {/* <br /> */}
                              <SubscriptionDescription>
                                <InfoContainerText>
                                  {/* <b>Inscrição: {index + 1}°</b>{" "} */}
                                  {/* <span>sem luta</span> */}
                                  <span>
                                    <b>Nome:</b>{" "}
                                    {value.fighters
                                      ? value.fighters.name
                                      : value.user.name}
                                  </span>
                                  <span>
                                    <b>Faixa: </b> {value.belt}
                                  </span>

                                  <span>
                                    <b>Idade de luta:</b> {value.age + " anos"}
                                  </span>

                                  <span>
                                    <b>Peso:</b> {value.weight.split(";")[0]}
                                  </span>

                                  <span>
                                    <b>Academia: </b>{" "}
                                    {value.fighters
                                      ? value.fighters.gym
                                      : value.user.gym}
                                  </span>

                                  {/* Peso máximo permitido */}
                                  <span>
                                    <b>Peso máximo permitido: </b>
                                    {getPesoMaximo(value) ||
                                      "Não encontrado nas regras"}
                                  </span>

                                  {/* <span>Professor: ORLEY LOBATO</span><br/> */}
                                </InfoContainerText>
                                {/* <InfoContainerStatus>
                                  <StatusButton status={value.status}>
                                    <span>
                                      {value.status
                                        ? "Pagamento efetuado"
                                        : "Pendente de pagamento"}
                                    </span>
                                  </StatusButton>
                                </InfoContainerStatus> */}
                              </SubscriptionDescription>
                            </SubscriptionContent>
                          </SubscriptionItem>
                        </SubscriptionList>
                      ))}
                    </React.Fragment>
                  );
                } else {
                  // não há atletas nesta categoria, então não renderizar nada
                  return null;
                }
              })}
          </SubscriptionContainer>
        </Content>

        <Content
          id="relatorioTorneio"
          style={{ alignContent: "left", justifyContent: "left" }}
        >
          {/* Campo de entrada para a senha */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: "200px",
            }}
          >
            <FormContent onSubmit={handleSubmit(handleCheckPassword)}>
              <FormGroup>
                <Input
                  label="Senha"
                  name="password"
                  type="password"
                  register={register}
                  required
                  error="Este campo é obrigatório"
                  trim={true}
                />
              </FormGroup>
              <FormGroup>
                <Button type="submit">Entrar</Button>
              </FormGroup>
            </FormContent>
          </div>

          {/* Botão para verificar a senha */}
          {isAuthorized && (
            <div style={{ paddingLeft: 16, paddingRight: 16 }}>
              <h1>Relatório de Inscrições</h1>
              <h2>{quantidadeInscrcaoPagas} Inscrições</h2>
              <h2>{quatidadeDeChaves} Total de Chaves</h2>
              <h2>{quatidadeDeChavesSemLuta} Chaves sem Luta</h2>
              <h2>
                {quatidadeDeChaves - quatidadeDeChavesSemLuta} Chaves com luta
              </h2>

              <h1>Relatório de Medalhas</h1>
              <h2>{medalhasOuro} Ouro</h2>
              <h2>{medalhasPrata} Prata</h2>
              <h2>{medalhasBronze} Bronze</h2>
              <hr />

              <h1> Todas as incrições</h1>

              <TournamentLink
                href={`/subscription/by-owner/${tournament.slug}`}
              >
                Ver Todas As Inscrições
              </TournamentLink>
              <TournamentLink href={`/reportDetail/tournament/${slug}`}>
                Relatório detalhado
              </TournamentLink>

              <ScrollableTable
                columns={columns}
                countCategories={countCategories}
                maxHeight={600}
                borderColor="#3333"
                scrollColor="#000"
              />

              <h1 style={{ marginTop: "50px" }}>Detalhamento das Inscrições</h1>

              <div
                style={{ display: "flex", gap: "10px", marginBottom: "20px" }}
              >
                <Button
                  variant={filterShirt === "all" ? "contained" : "outlined"}
                  color="secondary"
                  onClick={() => setFilterShirt("all")}
                >
                  Todos
                </Button>

                <Button
                  variant={filterShirt === "without" ? "contained" : "outlined"}
                  color="secondary"
                  onClick={() => setFilterShirt("without")}
                >
                  Sem Camisa
                </Button>

                <Button
                  variant={filterShirt === "with" ? "contained" : "outlined"}
                  color="secondary"
                  onClick={() => setFilterShirt("with")}
                >
                  Com Camisa
                </Button>
              </div>

              {[...subscription.flatMap((c: any) => c.data)]
                // 🔥 FILTRO NOVO (não mexe em nada do que já existe)
                .filter((v: any) => {
                  if (filterShirt === "all") return true;
                  if (filterShirt === "with") return v.tShirts != null;
                  if (filterShirt === "without") return v.tShirts == null;
                  return true;
                })
                //.sort((a: any, b: any) => b.id - a.id) // ordenação NUMERO DE INSCRIÇÃ0
                .sort((a: any, b: any) => {
                  const nomeA = (
                    a.fighters?.name ??
                    a.user?.name ??
                    ""
                  ).toUpperCase();
                  const nomeB = (
                    b.fighters?.name ??
                    b.user?.name ??
                    ""
                  ).toUpperCase();
                  return nomeA.localeCompare(nomeB);
                })
                .map((value: any, index: number) => {
                  const atleta = value.fighters ?? value.user;
                  const camisaGratis =
                    value.tShirts?.price === 999 ? "CAMISA GRÁTIS" : null;

                  return (
                    <SubscriptionList key={"detalhe-" + value.id}>
                      <SubscriptionItem
                        style={{
                          backgroundColor:
                            value.genre?.toLowerCase() === "feminino"
                              ? "#fee0f1"
                              : "#DBECF4", // MESMA COR
                        }}
                      >
                        <SubscriptionContent>
                          <SubscriptionDescription>
                            <InfoContainerText>
                              <span>
                                <b>{tournament.name}</b>
                              </span>

                              <span>
                                <b>Inscrição Nº {value.id}</b>
                              </span>

                              <span>
                                <b>Valor:</b> R$ {value.valueSubscription}
                                <b> status: </b>
                                {value.status
                                  ? "Pagamento efetuado"
                                  : "Pendente de pagamento"}
                              </span>

                              <span>
                                <b>Nome:</b> {atleta.name.toUpperCase()}
                              </span>

                              <span>
                                <b>Contato: </b> {atleta.phone}
                              </span>

                              <span>
                                <b>Idade de luta:</b> {value.age} anos
                                <b> Gênero:</b> {value.genre.toUpperCase()}
                              </span>

                              <span>
                                <b>Equipe:</b> {atleta.gym.toUpperCase()}
                              </span>

                              <span>
                                <b>Responsável pela inscrição:</b>{" "}
                                {value.user?.name?.toUpperCase()}
                              </span>

                              <span>
                                <b>Contato do responsável: </b>
                                {value.user?.phone}
                              </span>

                              <span>
                                <b>Categoria(s):</b>{" "}
                                {value.genre?.toUpperCase()} (
                                {value.category?.toUpperCase()}) /{" "}
                                {value.belt?.toUpperCase()} /{" "}
                                {value.weight?.toUpperCase()} /{" "}
                                {getPesoMaximo(value) ||
                                  "Não encontrado nas regras"}
                              </span>

                              {/* <span>
                                <b>Peso máximo permitido:</b>{" "}
                                {getPesoMaximo(value) ||
                                  "Não encontrado nas regras"}
                              </span> */}

                              <span>
                                <b>Camisa:</b>{" "}
                                {!value.tShirts
                                  ? "Sem camisa"
                                  : `${value.tShirts.measure} (${
                                      value.tShirts.size
                                    }) - ${value.tShirts.color} - ${
                                      value.tShirts.price === 999
                                        ? "CAMISA GRÁTIS"
                                        : `R$${value.tShirts.price}`
                                    }`}
                              </span>
                            </InfoContainerText>
                          </SubscriptionDescription>
                        </SubscriptionContent>
                      </SubscriptionItem>
                    </SubscriptionList>
                  );
                })}

              {/* ================================================
    TABELA REPETIDA NO FINAL DA PÁGINA (LUTAS + TEMPO)
==================================================== */}
              <div style={{ padding: "20px", marginTop: "40px" }}>
                <h1
                  style={{
                    fontSize: "1.8rem",
                    fontFamily: "inter, sans-serif",
                  }}
                >
                  Quantidade de atletas por categoria (Final da Página)
                </h1>

                <ScrollableTable
                  columns={[
                    { label: "Categoria", key: "title" },
                    { label: "Atletas", key: "total" },
                    { label: "Lutas", key: "lutas" },
                    { label: "Tempo (min)", key: "tempoDeLuta" },
                    { label: "Total min", key: "tempoTotal" },
                  ]}
                  countCategories={subscription.map((item: any) => {
                    const total = item.data.length;

                    // =======================================
                    // LÓGICA DE LUTAS COM AS DUAS REGRAS
                    // =======================================
                    let lutas = 0;

                    if (total <= 1) {
                      lutas = 0;
                    }

                    if (total === 2) {
                      lutas = 1;
                    }

                    if (total === 3) {
                      // Regra simples
                      if (REGRA_CHAVE_3 === "chaveDe3Simples") {
                        lutas = 2;
                      }

                      // Regra melhor de 3
                      if (REGRA_CHAVE_3 === "chaveDe3MelhorDe3") {
                        lutas = 3;
                      }
                    }

                    if (total >= 4) {
                      lutas = total - 1;
                    }

                    // =======================================
                    // TEMPO DE LUTA (PEGANDO DAS REGRAS)
                    // =======================================
                    const subsExemplo = item.data[0];
                    const tempoDeLuta = getTempoDeLuta(subsExemplo) || 0;

                    // =======================================
                    // TEMPO TOTAL = QTDE DE LUTAS × TEMPO
                    // =======================================
                    const tempoTotal = lutas * tempoDeLuta;

                    return {
                      title: item.title,
                      total,
                      lutas,
                      tempoDeLuta,
                      tempoTotal,
                    };
                  })}
                  maxHeight={600}
                  borderColor="#3333"
                  scrollColor="#000"
                />
              </div>





{/* ============================================================
    AGRUPAMENTO DE CATEGORIAS POR TEMPO E NÚMERO DE ÁREAS
============================================================= */}

{(() => {
  // ================================
  // CONFIGURAÇÕES DEFINIDAS PELO USUÁRIO
  // ================================
  const EVENTO_INICIO = "10:00";          // horário que o evento inicia
  const AREAS_DE_LUTA = 3;                // quantidade de áreas simultâneas
  const PERIODO_MINUTOS = 20;             // tamanho do bloco (ex: 60min = 1h)

  // Limite de minutos por bloco (período × áreas)
  const LIMITE_BLOCO = PERIODO_MINUTOS * AREAS_DE_LUTA;

  // ================================
  // PREPARAÇÃO DOS DADOS
  // ================================
  const categoriasProcessadas = subscription.map((item: any) => {
    const total = item.data.length;

    // Cálculo das lutas (já funcionando)
    let lutas = total > 1 ? total - 1 : 0;

    if (total === 3) {
      if (REGRA_CHAVE_3 === "chaveDe3MelhorDe3") lutas = 3;
      if (REGRA_CHAVE_3 === "chaveDe3Simples") lutas = 2;
    }

    // Tempo por luta conforme a faixa
    const subsExemplo = item.data[0];
    const tempoDeLuta = getTempoDeLuta(subsExemplo) || 0;

    const tempoTotal = lutas * tempoDeLuta;

    return {
      title: item.title,
      total,
      lutas,
      tempoDeLuta,
      tempoTotal,
    };
  });

// ================================
// AGRUPAMENTO EM BLOCOS DE TEMPO
// ================================
const blocos: any[] = [];
let blocoAtual: any[] = [];
let somaAtual = 0;

categoriasProcessadas.forEach((cat: any) => {
  if (somaAtual + cat.tempoTotal <= LIMITE_BLOCO) {
    blocoAtual.push(cat);
    somaAtual += cat.tempoTotal;
  } else {
    blocos.push({
      categorias: blocoAtual,
      minutos: somaAtual,
    });
    blocoAtual = [cat];
    somaAtual = cat.tempoTotal;
  }
});

  // adiciona o último bloco
  if (blocoAtual.length > 0) {
    blocos.push({
      categorias: blocoAtual,
      minutos: somaAtual,
    });
  }

  // ================================
  // FUNÇÃO AUXILIAR PARA SOMAR HORA
  // ================================
  const somarMinutos = (hora: string, min: number) => {
    const [h, m] = hora.split(":").map(Number);
    const total = h * 60 + m + min;
    const hh = String(Math.floor(total / 60)).padStart(2, "0");
    const mm = String(total % 60).padStart(2, "0");
    return `${hh}:${mm}`;
  };

  // ================================
  // RENDERIZAÇÃO DA NOVA TABELA
  // ================================
  let horarioAtual = EVENTO_INICIO;

  return (
    <div style={{ padding: "20px", marginTop: "40px" }}>
      <h1 style={{ fontSize: "1.8rem", fontFamily: "inter, sans-serif" }}>
        AGRUPAMENTO POR TEMPO E ÁREAS
      </h1>

      <TableContainer sx={{ marginTop: 2, border: "1px solid #3333" }}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell><b>Bloco</b></TableCell>
              <TableCell><b>Horário</b></TableCell>
              <TableCell><b>Minutos (total)</b></TableCell>
              <TableCell><b>Categorias</b></TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {blocos.map((bloco, index) => {
              const inicio = horarioAtual;
              const fim = somarMinutos(inicio, PERIODO_MINUTOS);

              // avança horário para o próximo bloco
              horarioAtual = fim;

              return (
                <TableRow key={index}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>
                    {inicio} — {fim}
                  </TableCell>
                  <TableCell>{bloco.minutos} min</TableCell>
                  <TableCell>
                    {bloco.categorias.map((c: any, i: number) => (
                      <div key={i}>{c.title}</div>
                    ))}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
})()}




            </div>
          )}
        </Content>

        <HistoryModal
          open={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          history={historyData}
          title="Inscrição"
          fieldLabels={{
            weight: "Peso",
            category: "Categoria",
            age: "Idade",
            belt: "Faixa",
          }}
          hiddenFields={[
            "tournamentId",
            "valueSubscription",
            "combo_subscription",
            "userId",
            "genre",
            "fightersId",
            "status",
            "tshirtId",
            "championGuarantee",
            "priceChampionGuarantee",
          ]}
        />

        <Zoom in={visible}>
          <Fab
            color="primary"
            size="medium"
            onClick={scrollToTop}
            sx={{
              position: "fixed",
              bottom: 24,
              right: 24,
              backgroundColor: "#373737",
              borderRadius: "50%", // garante que fique redondo
            }}
          >
            <KeyboardArrowUpIcon />
          </Fab>
        </Zoom>
      </Container>
    </>
  );
};

export default AllCheckCategoriesStiOpenKidsDeJiuJitsu2026;
